import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Settings } from "@core/store/settings/settings.model";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material";
import { FileSystemFileEntry, UploadEvent } from "ngx-file-drop";
import { NotificationsService } from "angular2-notifications";
import { environment } from "@env/environment";
import { CurrencyService } from "@core/services/currency.service";

@Component({
  selector: "user-settings",
  templateUrl: "./user-settings.component.html",
  styleUrls: ["./user-settings.component.scss"],
})
export class UserSettingsComponent implements OnInit {
  form: FormGroup;
  logo;
  logoUrl: string;
  defaultColor: string;
  currencies: Object;

  objectKeys = Object.keys;

  @Input() settings: Settings;
  @Output() saved = new EventEmitter<Settings>();

  @ViewChild("fileInput") fileInput;

  supportedLanguages = environment.SUPPORTED_LANGUAGES;

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<UserSettingsComponent>,
    private notificationService: NotificationsService,
    private currencyService: CurrencyService,
  ) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      name: [this.settings.name, Validators.required],
      contactInfo: this.settings.contactInfo,
      currency: [this.settings.currency, Validators.required],
      numberingSystem: [this.settings.numberingSystem, Validators.required],
      language: [this.settings.language, Validators.required],
    });

    if (this.settings.logo) {
      this.logoUrl = this.settings.logo;
    }

    this.defaultColor = this.settings.defaultColor
      ? this.settings.defaultColor
      : "#3EA8C9";

    this.currencies = this.currencyService.getCurrencies();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  save(data) {
    if (this.logo) {
      data.logoFile = this.logo;
    }
    if (this.defaultColor) {
      data.defaultColor = this.defaultColor;
    }
    this.saved.emit(Object.assign({}, this.settings, data));
    this.closeDialog();
  }

  public dropped(event: UploadEvent) {
    const droppedFile = event.files[0];

    // Is it a file?
    if (droppedFile.fileEntry.isFile) {
      const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
      fileEntry.file((file: File) => {
        this.addLogo(file);
      });
    }
  }

  public uploadLogo() {
    const fi = this.fileInput.nativeElement;
    if (fi.files && fi.files[0]) {
      this.addLogo(fi.files[0]);
    }
  }

  private addLogo(file: File) {
    const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
    if (!allowedExtensions.exec(file.name)) {
      this.notificationService.error(
        "File not supported",
        "Only jpeg and png images are allowed",
      );
      return false;
    }

    this.logo = file;

    const reader = new FileReader();

    reader.onload = (event: any) => {
      this.logoUrl = event.target.result;
    };

    reader.readAsDataURL(file);
  }
}



// WEBPACK FOOTER //
// /app/src/app/settings/components/user-settings/user-settings.component.ts